import { useState } from "react";
import CharacteristicRow from "./CharactersticRow";

const ServiceIcons = {
  0: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} style={{ width: 16, height: 16 }}>
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  ),
  1: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} style={{ width: 16, height: 16 }}>
      <circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/>
    </svg>
  ),
  2: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} style={{ width: 16, height: 16 }}>
      <path d="M12 2a10 10 0 1 0 10 10"/><path d="M12 6v6l4 2"/>
    </svg>
  ),
};

// ── ServiceSection ────────────────────────────────────────────────────────────
const ServiceSection = ({ svc, index, selected, onSelect }) => {
  const [collapsed, setCollapsed] = useState(false);
  const hasSelected = (svc.characteristics || []).some(c => selected?.char_id === c.id);
 
  return (
    <div style={{
      marginBottom: 20,
      border: `1px solid ${hasSelected ? "#bfdbfe" : "#f1f5f9"}`,
      borderRadius: 12,
      overflow: "hidden",
      transition: "border-color 0.2s",
      background: "white",
    }}>
      {/* Section header */}
      <div
        onClick={() => setCollapsed(v => !v)}
        style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          padding: "10px 14px",
          background: hasSelected
            ? "linear-gradient(90deg, #eff6ff 0%, #f0f9ff 100%)"
            : "linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%)",
          cursor: "pointer",
          transition: "background 0.2s",
          borderBottom: collapsed ? "none" : "1px solid #f1f5f9",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{
            width: 28, height: 28, borderRadius: 8,
            background: hasSelected
              ? "linear-gradient(135deg, #1e40af, #1d4ed8)"
              : "linear-gradient(135deg, #475569, #334155)",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "white", flexShrink: 0,
          }}>
            {ServiceIcons[index % 3]}
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 700, color: hasSelected ? "#1e40af" : "#374151", letterSpacing: 0.3 }}>
              {svc.description}
            </div>
            <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 1 }}>
              {svc.characteristics?.length ?? 0} characteristic{svc.characteristics?.length !== 1 ? "s" : ""}
              {hasSelected && <span style={{ color: "#1d4ed8", fontWeight: 600, marginLeft: 6 }}>· 1 selected</span>}
            </div>
          </div>
        </div>
        <div style={{
          width: 22, height: 22, borderRadius: 6,
          background: "#e2e8f0",
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "transform 0.2s",
          transform: collapsed ? "rotate(-90deg)" : "rotate(0deg)",
        }}>
          <svg viewBox="0 0 12 12" fill="none" style={{ width: 10, height: 10 }}>
            <path d="M2 4l4 4 4-4" stroke="#64748b" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
 
      {/* Characteristics */}
      {!collapsed && (
        <div style={{ padding: "10px 10px 6px" }}>
          {(svc.characteristics || []).map((char, i) => (
            <CharacteristicRow
              key={char.id}
              char={char}
              service={svc}
              isSelected={selected?.char_id === char.id}
              index={i}
              onClick={() => onSelect({
                service_id:   svc.service_id,
                service_uuid: svc.service_uuid,
                char_id:      char.id,
                char_uuid:    char.char_uuid,
                char_desc:    char.description,
                can_read:     char.properties?.includes("read"),
                can_write:    char.properties?.includes("write"),
                can_notify:   char.properties?.includes("notify"),
              })}
            />
          ))}
        </div>
      )}
    </div>
  );
};


export default ServiceSection;